import * as actions from "./entity.actions";
import * as mutations from "./entity.mutations";
import * as getters from "./entity.getters";
import state from "./entity.state";
// make our modules namespaced to avoid method name conflicts
const namespaced = true;

const entity = {
  namespaced,
  getters,
  mutations,
  actions,
  state
};

export default entity;
